module.exports = __webpack_public_path__ + "static/ten_ui_design_tips-6e390781cbf0db445466ba07193f36f8.png";